(() => {
  document.documentElement.dataset.cartAnalyticsReady = 'true';

  const publish = (event, payload = {}) => {
    const eventPayload = {
      ...payload,
      page_path: window.location.pathname,
      viewport: window.matchMedia('(max-width: 699px)').matches ? 'mobile' : 'desktop',
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...eventPayload });
    window.Shopify?.analytics?.publish?.(`the_limely:${event}`, eventPayload);
    document.documentElement.dataset.cartAnalyticsLastEvent = event;
  };

  const cartSummary = () => {
    const footer = document.querySelector('#cart-drawer [data-cart-summary]');

    return {
      currency: footer?.dataset.cartCurrency || 'JPY',
      item_count: Number(footer?.dataset.cartItemCount || 0),
      value: Number(footer?.dataset.cartTotal || 0) / 100,
    };
  };

  document.addEventListener('click', (event) => {
    const cartTrigger = event.target.closest('[aria-controls="cart-drawer"]');

    if (cartTrigger && !cartTrigger.closest('#cart-drawer')) {
      publish('cart_drawer_open', {
        ...cartSummary(),
        source: cartTrigger.closest('header') ? 'header' : 'page',
      });
      return;
    }

    const removeTrigger = event.target.closest('#cart-drawer [data-cart-remove]');

    if (removeTrigger) {
      const item = removeTrigger.closest('[data-cart-line-item]');
      publish('cart_remove_click', {
        ...cartSummary(),
        product_id: item?.dataset.productId || '',
        variant_id: item?.dataset.variantId || '',
        item_name: item?.dataset.productTitle || '',
        item_price: Number(item?.dataset.itemPrice || 0) / 100,
        quantity: Number(item?.dataset.quantity || 0),
      });
      return;
    }

    const recommendation = event.target.closest('#cart-drawer .horizontal-product-card');

    if (recommendation) {
      const title = recommendation.querySelector('.product-title');
      publish('cart_recommendation_click', {
        ...cartSummary(),
        item_name: title?.textContent?.trim() || '',
        item_url: title?.getAttribute('href') || '',
        interaction: event.target.closest('button') ? 'quick_add' : 'product_link',
      });
      return;
    }

    const checkoutTrigger = event.target.closest('#cart-drawer button[name="checkout"]');

    if (checkoutTrigger) {
      publish('cart_checkout_click', cartSummary());
    }
  });

  document.addEventListener('cart:change', (event) => {
    const cart = event.detail?.cart;
    if (!cart) return;

    publish('cart_state_change', {
      cart_action: event.detail?.baseEvent || 'unknown',
      currency: cart.currency || 'JPY',
      item_count: Number(cart.item_count || 0),
      line_item_count: Array.isArray(cart.items) ? cart.items.length : 0,
      value: Number(cart.total_price || 0) / 100,
    });
  });
})();
